import React from 'react';
import ArcaApresentacoesWorkspace from './components/ArcaApresentacoesWorkspace';

/** Aba Apresentações — workspace split-screen (Passo 3). */
export default function ArcaApresentacoesPage() {
  return <ArcaApresentacoesWorkspace />;
}
